import { CSSProperties } from 'react';
import styled from 'styled-components';
import { Layout } from '@goalsetter/ant-design-ui';

const StyledGradientLayout = styled(Layout.Content).withConfig({
  shouldForwardProp: (prop) => !['withHeader', 'background'].includes(prop),
})<{ withHeader?: boolean; background?: string }>`
  display: flex;
  padding-left: ${({ theme }) => theme.padding}px;
  padding-right: ${({ theme }) => theme.padding}px;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-height: ${({ withHeader }) =>
    withHeader ? 'calc(100vh - 72px)' : '100vh'};
  margin-top: ${({ withHeader }) => (withHeader ? '72px' : 0)};
  justify-content: center;
  position: relative;
  background: ${({ background }) =>
    background ??
    'var( --Gradient, linear-gradient(180deg, #26155b 0%, #74279b 100%))'};
`;

const StyledBreakpointsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['breakpointSM'].includes(prop),
})<{ breakpointSM: number }>`
  display: flex;
  width: 100%;
  max-width: 800px;
  min-height: calc(100vh - 72px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.padding}px;
  align-self: center;
`;

const headerContainerStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 1000,
};

const layoutStyle: CSSProperties = {
  width: '100vw',
  minHeight: '100vh',
};

export {
  StyledGradientLayout,
  StyledBreakpointsContainer,
  headerContainerStyle,
  layoutStyle,
};
